const execAsync = require('libraries/execAsync')
const moment = require('moment')
const sh = require('shelljs')
const fs = require('fs')
const {
    config,
    begin,
    finish,
    newline,
    error,
    accent,
    faded,
    spinner,
    inquirer
} = require('../common.js')
const clientDirectory = config.get("ops_client_path")

// TO DO - filter out "merge" and "stash" messages
// TO DO - automate branch syncing
// TO DO - implement sync-only flow

module.exports = yargs => {
    
    const argv = yargs
        .reset()
        .option("sync-only", {
            alias: "s",
            description: "sync with master and deploy branch without touching the package or changelog"
        })
        .argv

    begin('deploy')
        
        .then(validateDirectory)
        .then(validateBranch)
        
        .then(getVersion)
        .then(getDeployBranch)
        
        .then(writeVersion)
        .then(writeChangelog)
        
        .then(confirmSync)
        .then(syncBranches)

        .then(finish)
        
        .catch(({ message }) => {
            spinner.stop()
            error('deploy', message)
            finish()
        })
    
}

// make sure the user is in the ops client directory
const validateDirectory = () => {
    const workingDirectory = sh.exec("pwd", { silent: true }).stdout.trim()
    if (workingDirectory !== clientDirectory) 
        throw new Error(
            'this command must be run from the ops client directory:\n\n' + 
            '\t' + accent("cd " + clientDirectory)
        )
}

// make sure this is being run from an X.X branch
const validateBranch = () => {
    
    const branchName = require('current-git-branch')()
    const branchRegex = /^\d+\.\d+$/
    if (!branchRegex.test(branchName)) 
        throw new Error(
            'this command must be run from a version branch\n' +
            '\t' + "(e.g. 2.6)."
        )
    
    return { branchName }

}

// figure out full deploy version and isPatch
const getVersion = ({ 
    branchName, ...rest 
}) => new Promise((resolve, reject) => {

    fs.readFile(clientDirectory + '/package.json', 'utf8', (err, data) => {
        if (err) return reject(err)
        
        let version 
        try 
        {
            version = JSON.parse(data).version
        }
        catch(err)
        {
            return reject(err)
        }

        let newVersion
        if (version.includes(branchName))
        {
            const newPatch = parseInt(version.split('.')[2]) + 1
            newVersion = branchName + '.' + newPatch
        }
        else
            newVersion = branchName + '.0'
        
        const [ major, minor, patch ] = newVersion.split('.')
        
        console.log('\tset version\n')
        
        return inquirer
            .prompt([{
                type: 'input',
                name: 'finalPatch',
                message: faded('major ') + major + '\n\t' +
                    faded('minor ') + minor + '\n\t' + 
                    faded('patch'),
                default: patch
            }])
            .then(({ finalPatch }) => {
                const finalVersion = branchName + '.' + finalPatch
                console.log('\n\tdeploy version: ' + accent(finalVersion))

                return resolve({
                    ...rest,
                    branchName,
                    version: finalVersion
                })
                
            })
            .catch(reject)
        })
})
    


const getDeployBranch = data => new Promise((resolve, reject) => {

    newline()

    spinner.start('fetching deploy branches')

	execAsync(
		`git fetch --all && git pull && git branch --list 'deploy*'`,
		{ silent: true }
    )
        .then(stdout => {
            spinner.stop()
            const branchOptions = stdout
                .split('\n')
                .slice(-6, -1)
                .map(branch => branch.trim())
                .reverse()

            return branchOptions
        })
        .then(branchOptions => inquirer.prompt([{
            type: 'list',
            name: 'deployBranch',
            choices: branchOptions,
            message: 'deploy branch:'
        }]))
        .then(({ deployBranch }) => resolve({
            ...data,
            deployBranch
        }))
        .catch(reject)
    
})

const writeVersion = data => new Promise((resolve, reject) => {
    
    newline()
    
    spinner.start('updating package.json')
    
    const pkgPath = clientDirectory + '/package.json'
    
    fs.readFile(pkgPath, 'utf8', (err, pkgData) => {
        if (err) return reject(err)
        
        let pkg 
        try 
        {
            pkg = JSON.parse(pkgData)
        }
        catch(err)
        {
            return reject(err)
        }
        
        pkg.version = data.version
        
        const writeData = JSON.stringify(pkg, null, 2)
        fs.writeFile(pkgPath, writeData, 'utf8', err => {
            if (err) return reject(err)
            spinner.stop()
            return resolve(data)
        })

    })


})

const writeChangelog = data => new Promise((resolve, reject) => {
    
    // spinner.start('updating CHANGELOG.md')
    
    const changeLogPath = clientDirectory + '/CHANGELOG.md'
    
    fs.readFile(changeLogPath, 'utf8', (err, changelog) => {
        if (err) return reject(err)

        const mostRecentRegex = /^> Released (.*)$/m
        const mostRecentEntry = changelog.match(mostRecentRegex)[1]
        const since = moment(mostRecentEntry, 'MMM D, YYYY')
            .add(-1, 'day')
            .format('YYYY-MM-DD')

        const format = '  %s (%an)'
        const command = `git log --oneline --decorate --since="${
                since
            }" --format="${
                format
            }"`

        execAsync(
            command,
            { silent: true }
        )
            .then(gitDump => {

                let toPrepend = '## ' + data.version + '\n\n' +
                    '> Released ' + moment().format('MMM D, YYYY') + '\n\n' + 
                    '### New Features\n\n' +
                    '### Improvements\n\n' +
                    '### Bug Fixes\n\n' +
                    '<!-- \n\n' + gitDump + '\n-->' + '\n\n'
        
                // minor release gets different formatting
                if (data.version.split('.')[2] === '0') 
                    toPrepend = toPrepend + "---\n\n"
        
                const writeData = toPrepend + changelog
                
                fs.writeFile(changeLogPath, writeData, 'utf8', err => {
                    if (err) return reject(err)
                    spinner.stop()
                    const editor = config.get("preferred_editor")
                    sh.exec(`open -a "${editor}" ${changeLogPath}`)
                    return resolve(data)
                })
            })
            .catch(reject)
        

    })

})

const confirmSync = data => {

    console.log('\tplease finish the changelog before the client syncs\n')
    
    return inquirer
        .prompt([{
            type: 'confirm',
            name: 'shouldSync',
            message: 'ready to sync?'
        }])
        .then(({ shouldSync }) => {
            if (shouldSync)
                return data
            else
            {
                console.log('\t\nexiting deploy script')
                finish()
            }
        })

}


const syncBranches = data => execAsync(
    'git add -A && ' +
    //  `git commit -m "prep for deploy of ${data.version} && "` +
     `git commit -m "prep for deploy of ${data.version}"`,
    //  "git pull &&" +
    //  "git push",
    { silent: true }
)
    .then(stdout => {
        
        console.log('\n\tautomated syncing is still under construction')
        console.log('\n\tplease sync manually with:')
        console.log(`\t- ${data.branchName} (origin)`)
        console.log(`\t- ${data.deployBranch}`)
        console.log('\t- master')
    })


// WEBPACK FOOTER //
// ./src/commands/deploy.js